import { useState } from "react";
import { signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider, signOut } from "firebase/auth";
import { auth } from "../firebase";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { IconBrandGoogle } from "@tabler/icons-react";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const db = getFirestore();

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const checkAdmin = async (uid) => {
    try {
      const userRef = doc(db, "users", uid);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        return userSnap.data().admin === true ? "ok" : "not-admin";
      }
      return "not-found";
    } catch {
      return "permission-error";
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    try {
      const userCred = await signInWithEmailAndPassword(auth, email, password);
      const status = await checkAdmin(userCred.user.uid);
      if (status === "ok") return; // App.js re-verifies and redirects once admin status resolves
      await signOut(auth);
      if (status === "not-admin") setError("Access denied. This account does not have admin privileges.");
      else if (status === "not-found") setError("No user record found. Please contact support.");
      else setError("You do not have permission to access the CMS.");
    } catch {
      setError("Login failed. Please check your credentials.");
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const userCred = await signInWithPopup(auth, provider);
      const status = await checkAdmin(userCred.user.uid);
      if (status === "ok") return; // App.js re-verifies and redirects once admin status resolves
      await signOut(auth);
      if (status === "not-admin") setError("Access denied. This account does not have admin privileges.");
      else if (status === "not-found") setError("No user record found. Please contact support.");
      else setError("You do not have permission to access the CMS.");
    } catch {
      setError("Google sign-in failed.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Admin Login</h2>

        {error && <div className="alert-error">{error}</div>}

        <form
          onSubmit={handleLogin}
          style={{ display: "flex", flexDirection: "column", gap: 16 }}
        >
          <div>
            <label className="input-label">Email</label>
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
            />
          </div>

          <div>
            <label className="input-label">Password</label>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>

          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontSize: 13,
              fontWeight: 600,
              color: "var(--darkgrey)",
              cursor: "pointer",
              userSelect: "none",
            }}
          >
            <input
              type="checkbox"
              checked={showPassword}
              onChange={(e) => setShowPassword(e.target.checked)}
              style={{ width: "auto", cursor: "pointer" }}
            />
            Show password
          </label>

          <button
            type="submit"
            className="primary-button"
            style={{
              backgroundColor: "var(--primary)",
              color: "#fff",
              borderColor: "var(--primary-shadow)",
              width: "100%",
              fontSize: 16,
              padding: "13px 20px",
              borderRadius: 15,
            }}
          >
            Sign In
          </button>
        </form>

        <div className="login-divider">
          <div className="login-divider-line" />
          <span className="login-divider-text">or</span>
          <div className="login-divider-line" />
        </div>

        <button
          type="button"
          className="primary-button"
          onClick={handleGoogleSignIn}
          style={{
            backgroundColor: "transparent",
            color: "var(--text)",
            borderColor: "var(--grey)",
            width: "100%",
            fontSize: 15,
            padding: "12px 20px",
            borderRadius: 15,
          }}
        >
          <IconBrandGoogle size={18} />
          Sign in with Google
        </button>
      </div>
    </div>
  );
}

export default Login;
